export enum DateTimeFieldAccuracy {
  Unknown = 0,
  Year = 10,
  YearMonth = 20,
  Date = 30,
  DateTime = 40,
  /** @deprecated Client side is needed only for the time-field Component logics*/
  TimeOnly = 50,
}

export enum DateTimeFieldBehaviour {
  Utc = 10, //This is shown/sent with the timezone of the BU (i.e. always UTC+/-N)
  Local = 20, //This is shown/sent with no timezone conversion (i.e. BU Timezone set on arrival and stripped on departure)
}

export enum DateTimeFieldVisualization {
  Default = 0,
  Split = 10,
}

// https://learn.microsoft.com/en-us/dotnet/standard/base-types/standard-date-and-time-format-strings
export enum DateTimeFieldFormat {
  Default = 0,
  g = 10,
  t = 20,
}
